import { tv } from 'tailwind-variants'

export const fieldContainer = tv({
  base: 'ios:items-center ios:h-full android:items-center android:h-full flex w-full flex-row justify-between',
})
